function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1003",
  "data-name": "Rectangle 1003",
  width: 151.337,
  height: 110,
  rx: 6,
  fill: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: -6.735,
  y1: 1,
  x2: -6.735,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.251
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.122
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.102
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Mask_Group_10",
  "data-name": "Mask Group 10",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("g", {
  id: "undraw_smart_home_28oy",
  transform: "translate(0 0.936)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_823",
  "data-name": "Path 823",
  d: "M97.383,27.929c-9.72-.334-18.978-3.446-27.817-6.85S51.969,13.9,42.483,12.1c-6.1-1.16-13.081-1.33-18,1.92-4.732,3.121-6.261,8.515-7.082,13.51-.619,3.762-.982,7.716.711,11.243,1.177,2.444,3.266,4.5,4.711,6.841,5.025,8.15,1.476,18.2-3.974,26.154-2.549,3.733-5.519,7.293-7.49,11.267S8.479,91.56,10.2,95.612c1.711,4.018,5.784,7.03,10.2,9.158,8.964,4.31,19.528,5.545,29.828,6.244,22.8,1.546,45.725.877,68.587.206,8.461-.249,16.958-.5,25.282-1.8,4.621-.72,9.392-1.863,12.747-4.623a10.532,10.532,0,0,0,2.461-13.836c-4.787-7.369-18.026-9.2-21.373-17.109-1.842-4.353.05-9.2,2.726-13.24,5.743-8.662,15.368-16.26,15.875-26.161.349-6.8-4.279-13.61-11.433-16.827-7.5-3.373-17.9-2.948-23.432,2.634C115.976,26.011,105.964,28.224,97.383,27.929Z",
  transform: "translate(-9.292 -11.338)",
  fill: "#f0d9db"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_990",
  "data-name": "Rectangle 990",
  width: 68.965,
  height: 82.347,
  rx: 5.257,
  transform: "translate(44.599 17.839)",
  fill: "#464353"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_991",
  "data-name": "Rectangle 991",
  width: 57.067,
  height: 65.733,
  transform: "translate(50.548 25.644)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.265,
  opacity: 0.1
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_94",
  "data-name": "Ellipse 94",
  cx: 2.429,
  cy: 2.408,
  rx: 2.429,
  ry: 2.408,
  transform: "translate(76.653 93.805)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_824",
  "data-name": "Path 824",
  d: "M164.657,56.549a1.144,1.144,0,1,1,.814-.33A1.142,1.142,0,0,1,164.657,56.549Z",
  transform: "translate(-85.575 -32.759)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_825",
  "data-name": "Path 825",
  d: "M164.584,54.275a1.08,1.08,0,0,1,1,.658,1.064,1.064,0,0,1-.233,1.17,1.087,1.087,0,0,1-1.18.231,1.07,1.07,0,0,1,.41-2.059m0-.133a1.214,1.214,0,0,0-1.122.745,1.2,1.2,0,0,0,.266,1.313,1.222,1.222,0,0,0,1.326.257,1.2,1.2,0,0,0-.469-2.314Z",
  transform: "translate(-85.503 -32.692)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_826",
  "data-name": "Path 826",
  d: "M161.133,80.673V78.332H162.9v2.341h1.8V77.162h1.151l-3.837-3.512-3.836,3.512h1.15v3.511Z",
  transform: "translate(-82.937 -42.425)",
  fill: "#e30613"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_827",
  "data-name": "Path 827",
  d: "M124.875,106.331V103.8a.541.541,0,0,0-1.083,0v2.528a1.094,1.094,0,0,0-.53,1.235,1.109,1.109,0,0,0,2.142,0A1.094,1.094,0,0,0,124.875,106.331Zm-.729-2.528a.185.185,0,0,1,.369,0v.567h-.369Z",
  transform: "translate(-65.647 -57.201)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.265
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_992",
  "data-name": "Rectangle 992",
  width: 32.202,
  height: 0.355,
  transform: "translate(66.185 48.439)",
  fill: "#e30613",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_95",
  "data-name": "Ellipse 95",
  cx: 0.849,
  cy: 0.842,
  rx: 0.849,
  ry: 0.842,
  transform: "translate(75.279 47.775)",
  fill: "#e30613"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_993",
  "data-name": "Rectangle 993",
  width: 9.944,
  height: 0.355,
  transform: "translate(66.185 48.439)",
  fill: "#e30613"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_828",
  "data-name": "Path 828",
  d: "M123.263,130.4a.193.193,0,0,0-.2-.168.2.2,0,0,0-.195.144l-.2,1.056a.406.406,0,0,0-.008.081.4.4,0,0,0,.805,0,.4.4,0,0,0-.013-.1Zm1.524.454a.523.523,0,0,0-.066-.045l-.794-.543a.162.162,0,0,0-.205.011.132.132,0,0,0-.021.176l.612.752a.343.343,0,0,0,.04.049.334.334,0,0,0,.433,0,.265.265,0,0,0,0-.4Zm.537-.776-.745-.027a.087.087,0,0,0-.1.069.1.1,0,0,0,.059.1h0l.721.2c.1.023.221-.025.221-.133,0-.133-.039-.2-.157-.214Zm-3.7.144a.1.1,0,0,0,.059-.1.089.089,0,0,0-.1-.069l-.743.027c-.119.013-.154.079-.154.213,0,.106.114.156.217.133l.721-.2Zm.608.043-.794.541a.43.43,0,0,0-.064.045.265.265,0,0,0,0,.4.323.323,0,0,0,.432,0,.232.232,0,0,0,.042-.048l.612-.749a.132.132,0,0,0-.021-.176.163.163,0,0,0-.211-.013Zm.851-3.507a1.444,1.444,0,0,1,.349.736.529.529,0,0,1-.139.4.539.539,0,0,1-.391.173.567.567,0,0,1-.4-.17.557.557,0,0,1-.16-.405v-.078a2.172,2.172,0,0,0-.5,1.393,1.242,1.242,0,0,0,2.485,0,2.082,2.082,0,0,0-1.244-2.05Zm-.044,2.82a.493.493,0,0,1-.5-.484.483.483,0,0,1,.436-.48,1.21,1.21,0,0,0,.719-.4,2.145,2.145,0,0,1,.091.623.743.743,0,0,1-.746.74Z",
  transform: "translate(-64.389 -68.922)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.265
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_994",
  "data-name": "Rectangle 994",
  width: 32.202,
  height: 0.355,
  transform: "translate(66.185 60.222)",
  fill: "#e30613",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_96",
  "data-name": "Ellipse 96",
  cx: 0.849,
  cy: 0.842,
  rx: 0.849,
  ry: 0.842,
  transform: "translate(82.793 59.558)",
  fill: "#e30613"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_995",
  "data-name": "Rectangle 995",
  width: 17.539,
  height: 0.355,
  transform: "translate(66.185 60.222)",
  fill: "#e30613"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_829",
  "data-name": "Path 829",
  d: "M123.056,155a.231.231,0,0,0,.231.229H124.3a.231.231,0,0,0,.231-.229v-.2h-1.476Zm.738-4.161a1.6,1.6,0,0,0-1.66,1.533,1.506,1.506,0,0,0,.708,1.264v.5a.227.227,0,0,0,.073.159.23.23,0,0,0,.165.061h1.428a.23.23,0,0,0,.165-.061.227.227,0,0,0,.073-.159v-.5a1.5,1.5,0,0,0,.71-1.264,1.6,1.6,0,0,0-1.661-1.533Z",
  transform: "translate(-65.106 -80.934)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.265
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_996",
  "data-name": "Rectangle 996",
  width: 32.202,
  height: 0.355,
  transform: "translate(66.185 71.923)",
  fill: "#e30613",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_97",
  "data-name": "Ellipse 97",
  cx: 0.849,
  cy: 0.842,
  rx: 0.849,
  ry: 0.842,
  transform: "translate(91.112 71.258)",
  fill: "#e30613"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_997",
  "data-name": "Rectangle 997",
  width: 25.858,
  height: 0.355,
  transform: "translate(66.185 71.923)",
  fill: "#e30613"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_830",
  "data-name": "Path 830",
  d: "M123.228,173.061v2.56h.738v2.2l1.476-2.927H124.7l.738-1.828Z",
  transform: "translate(-65.647 -92.02)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.265
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_998",
  "data-name": "Rectangle 998",
  width: 32.202,
  height: 0.355,
  transform: "translate(66.185 83.241)",
  fill: "#e30613",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_98",
  "data-name": "Ellipse 98",
  cx: 0.849,
  cy: 0.842,
  rx: 0.849,
  ry: 0.842,
  transform: "translate(75.279 82.575)",
  fill: "#e30613"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_999",
  "data-name": "Rectangle 999",
  width: 9.944,
  height: 0.355,
  transform: "translate(66.185 83.241)",
  fill: "#e30613"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_99",
  "data-name": "Ellipse 99",
  cx: 0.928,
  cy: 1.205,
  rx: 0.928,
  ry: 1.205,
  transform: "translate(45.105 94.623)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_100",
  "data-name": "Ellipse 100",
  cx: 0.928,
  cy: 1.205,
  rx: 0.928,
  ry: 1.205,
  transform: "translate(45.105 93.149)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_101",
  "data-name": "Ellipse 101",
  cx: 13.283,
  cy: 2.794,
  rx: 13.283,
  ry: 2.794,
  transform: "translate(105.058 102.783)",
  fill: "#e30613",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_831",
  "data-name": "Path 831",
  d: "M233.183,169.7a.77.77,0,0,0,.051.2,1.133,1.133,0,0,0,.44.605,1.2,1.2,0,0,0,.349.133,18.874,18.874,0,0,0,2.517.217,6.935,6.935,0,0,0,2.559.066.681.681,0,0,0,.483-.359.212.212,0,0,0,.012-.039,4.5,4.5,0,0,0,1.785-.028.684.684,0,0,0,.483-.359.805.805,0,0,0,.028-.321,6.247,6.247,0,0,0-.223-1.659,4.635,4.635,0,0,0-.229-.56q-.2-.419-.429-.818l-.047-.086c.113.049.223.1.331.16a27.739,27.739,0,0,0,1.085-4.711,16.429,16.429,0,0,0-.166-5.7,8.055,8.055,0,0,1-.134-1.9,19.823,19.823,0,0,1,.647-3.74q.225-.931.449-1.875l.641-2.671a5.95,5.95,0,0,0,.24-1.807,4.687,4.687,0,0,0-.2-.982,11.264,11.264,0,0,0-.564-1.509.257.257,0,0,0,.189-.039.32.32,0,0,0,.085-.166l.338-1.208a12.967,12.967,0,0,0,.537-2.577,28.068,28.068,0,0,0-.11-2.985c-.042-1.293.117-2.59.032-3.881-.019-.279-.048-.557-.082-.834.015-.146.019-.293.023-.439a5.172,5.172,0,0,0-.254-2.106,2.928,2.928,0,0,0-.884-1.216c.012-.06.025-.118.038-.178l.282-1.33a13.927,13.927,0,0,0,.447-4.486,4.765,4.765,0,0,0-1.854-3.393l-.009-.007-.114-.072-.02-.012c-.035-.021-.071-.041-.107-.06l-.027-.015c-.043-.024-.089-.047-.134-.067a4.266,4.266,0,0,0-1.073-.318l-.148-.023a4.154,4.154,0,0,0-.444-.045h-.149a3.1,3.1,0,0,0-.444.027.874.874,0,0,0-.164.027l-.161.033a6.844,6.844,0,0,1-.971.2c-.062,0-.125.008-.186.009-.187,0-.373-.012-.561-.023-.093,0-.186-.008-.279-.008a2.228,2.228,0,0,0-.46.041,1.948,1.948,0,0,0-.725.331,3.019,3.019,0,0,0-.44.388,4.42,4.42,0,0,0-.306.365c-.044.059-.087.118-.134.181l-.062.094c-.039.065-.076.133-.111.2a2.515,2.515,0,0,0-.134.309,1.463,1.463,0,0,0-.06.863,1.653,1.653,0,0,0,.059.18,3.36,3.36,0,0,0-.369,1.542,3.232,3.232,0,0,0,2.186,3.105c.154.282.342.641.5.99a3.588,3.588,0,0,0-.857.859,1.923,1.923,0,0,0-1.811,1.361,2.455,2.455,0,0,0-.1.931,9.349,9.349,0,0,0-.186,2.046c-.023,1.078-.079,2.153-.134,3.229s-.111,2.143-.168,3.216c-.016.307-.032.616-.072.921-.2.052-.207.319-.184.532.062.568.162,1.143.227,1.714a2.806,2.806,0,0,0-.055,1.076l.114.051a4.278,4.278,0,0,1-.161,1.087.388.388,0,0,1-.086.174.587.587,0,0,1,.178-.044c-.17.556-.306,1.126-.506,1.672-.1.282-.224.559-.313.847a7.881,7.881,0,0,0-.188.833,4.018,4.018,0,0,0-.071.49,2.058,2.058,0,0,0,.707,1.684c0,.109-.008.217-.008.326,0,.778.115,1.554.087,2.331-.038,1.047-.227,2.038-.232,3.087a25.683,25.683,0,0,0,1.727,8.461q.56,1.62,1.187,3.21a2.631,2.631,0,0,1,.26,1.946c.09-.036.178-.069.268-.1a2.792,2.792,0,0,1-.615.931,2.6,2.6,0,0,1-1.54.722,3.513,3.513,0,0,0-.836.112A.681.681,0,0,0,233.183,169.7Zm3.429-15.049a12.822,12.822,0,0,1,1.648-4.241l.008.087c.043.428.122.857.208,1.284a11.781,11.781,0,0,1,.358,2.7,15.254,15.254,0,0,0,.169,2.863,4.5,4.5,0,0,0,.268,1.083,5.73,5.73,0,0,1,.268.617,2.927,2.927,0,0,1,.107.765,27.3,27.3,0,0,1-.392,6.371c-.093,0-.152.015-.153.027a2.868,2.868,0,0,1-.366,1.019l-.016-.029c-.032-.056-.066-.12-.1-.184l.111.017a5.291,5.291,0,0,1-.293-2.155,19.677,19.677,0,0,0-.3-2.96,17.111,17.111,0,0,0-1.362-4.281,3.332,3.332,0,0,1-.268-.9A6.017,6.017,0,0,1,236.612,154.649Zm5.535-15.832a2.267,2.267,0,0,0-.162-.194c-.134-.142-.3-.307-.255-.5a.49.49,0,0,1,.113-.2,2.942,2.942,0,0,1,.357-.371l.043-.037q-.048.651-.1,1.305Z",
  transform: "translate(-119.772 -63.8)",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_832",
  "data-name": "Path 832",
  d: "M252.907,141.772l.148,1.13c.05.383.1.765.126,1.149.09,1.28-.077,2.565-.034,3.848a26.31,26.31,0,0,1,.117,2.959,12.459,12.459,0,0,1-.568,2.554l-.354,1.2a.235.235,0,0,1-.315.2l-1.573-.133c.1-.458.212-.931.268-1.4.043-.367.068-.737.1-1.107.083-1.152.178-2.3.268-3.459l.168-2.022a15.133,15.133,0,0,1,.368-2.613,5.189,5.189,0,0,1,1.285-2.3Z",
  transform: "translate(-128.576 -76.411)",
  fill: "#e30613"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_833",
  "data-name": "Path 833",
  d: "M252.907,141.772l.148,1.13c.05.383.1.765.126,1.149.09,1.28-.077,2.565-.034,3.848a26.31,26.31,0,0,1,.117,2.959,12.459,12.459,0,0,1-.568,2.554l-.354,1.2a.235.235,0,0,1-.315.2l-1.573-.133c.1-.458.212-.931.268-1.4.043-.367.068-.737.1-1.107.083-1.152.178-2.3.268-3.459l.168-2.022a15.133,15.133,0,0,1,.368-2.613,5.189,5.189,0,0,1,1.285-2.3Z",
  transform: "translate(-128.576 -76.411)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_834",
  "data-name": "Path 834",
  d: "M243.624,217.118a4.75,4.75,0,0,1,.242.556,5.94,5.94,0,0,1,.233,1.644.792.792,0,0,1-.03.318.7.7,0,0,1-.509.355,7.757,7.757,0,0,1-2.683-.065,20.363,20.363,0,0,1-2.643-.214,1.358,1.358,0,0,1-.366-.126,1.133,1.133,0,0,1-.463-.6.778.778,0,0,1-.052-.2.681.681,0,0,1,.507-.641,3.856,3.856,0,0,1,.877-.11,2.754,2.754,0,0,0,2.447-2.29,6.128,6.128,0,0,1,1.61.057,1.336,1.336,0,0,1,.385.5Q243.417,216.7,243.624,217.118Z",
  transform: "translate(-122.095 -113.301)",
  fill: "#a26565"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_835",
  "data-name": "Path 835",
  d: "M243.624,217.118a4.75,4.75,0,0,1,.242.556,5.94,5.94,0,0,1,.233,1.644.792.792,0,0,1-.03.318.7.7,0,0,1-.509.355,7.757,7.757,0,0,1-2.683-.065,20.363,20.363,0,0,1-2.643-.214,1.358,1.358,0,0,1-.366-.126,1.133,1.133,0,0,1-.463-.6.778.778,0,0,1-.052-.2.681.681,0,0,1,.507-.641,3.856,3.856,0,0,1,.877-.11,2.754,2.754,0,0,0,2.447-2.29,6.128,6.128,0,0,1,1.61.057,1.336,1.336,0,0,1,.385.5Q243.417,216.7,243.624,217.118Z",
  transform: "translate(-122.095 -113.301)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_836",
  "data-name": "Path 836",
  d: "M238.886,217.955a4.5,4.5,0,0,1,.242.555,5.877,5.877,0,0,1,.233,1.644.769.769,0,0,1-.03.318.7.7,0,0,1-.507.357,7.789,7.789,0,0,1-2.683-.067,20.363,20.363,0,0,1-2.643-.214,1.3,1.3,0,0,1-.366-.133,1.128,1.128,0,0,1-.463-.6.776.776,0,0,1-.052-.2.682.682,0,0,1,.507-.641,3.933,3.933,0,0,1,.877-.11,2.755,2.755,0,0,0,2.447-2.288,6.123,6.123,0,0,1,1.61.056,1.326,1.326,0,0,1,.386.5C238.6,217.407,238.748,217.679,238.886,217.955Z",
  transform: "translate(-119.752 -113.716)",
  fill: "#a26565"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_837",
  "data-name": "Path 837",
  d: "M232.671,177.687a24.162,24.162,0,0,0,1.813,8.381q.588,1.6,1.246,3.181a2.473,2.473,0,0,1,.275,1.929,4.746,4.746,0,0,1,2.47-.342,4.974,4.974,0,0,1-.306-2.129,18.511,18.511,0,0,0-.317-2.933,16.269,16.269,0,0,0-1.448-4.243,3.213,3.213,0,0,1-.28-.894,5.664,5.664,0,0,1,.119-2.063,12.245,12.245,0,0,1,1.731-4.2l.008.085a12.313,12.313,0,0,0,.217,1.273,11.046,11.046,0,0,1,.377,2.677,14.356,14.356,0,0,0,.177,2.838,4.284,4.284,0,0,0,.288,1.072c.093.206.213.4.286.613a2.774,2.774,0,0,1,.113.758,25.5,25.5,0,0,1-.445,6.484,4.183,4.183,0,0,1,2.163.488,26.225,26.225,0,0,0,1.14-4.67,15.386,15.386,0,0,0-.174-5.649,7.446,7.446,0,0,1-.141-1.882,18.651,18.651,0,0,1,.679-3.708l.472-1.863q.335-1.33.671-2.649a5.587,5.587,0,0,0,.252-1.791,4.411,4.411,0,0,0-.209-.974,10.829,10.829,0,0,0-1.485-3.012,59.427,59.427,0,0,1-7.782-.293.526.526,0,0,0-.365.061.51.51,0,0,0-.148.33l-.97,5.455a13.6,13.6,0,0,0-.268,2.3c0,.772.121,1.541.091,2.311C232.875,175.666,232.676,176.648,232.671,177.687Z",
  transform: "translate(-119.78 -87.58)",
  fill: "#454b69"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_838",
  "data-name": "Path 838",
  d: "M243.19,180.457a12.3,12.3,0,0,0,.217,1.273c.562-.965,1.169-1.905,1.687-2.894.134-.254.26-.512.388-.77l.382-.772c.071-.145.142-.29.207-.438a3.146,3.146,0,0,0,.24-.665c-.188-.035-.652.468-.792.6a10.764,10.764,0,0,0-.805.883,9.7,9.7,0,0,0-.853,1.091A5.279,5.279,0,0,0,243.19,180.457Z",
  transform: "translate(-124.983 -93.582)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_839",
  "data-name": "Path 839",
  d: "M238.916,130.733s1.436,2.268,1.17,2.743,4.522-.422,4.522-.422-2.607-2.268-2.34-3.218S238.916,130.733,238.916,130.733Z",
  transform: "translate(-122.869 -70.321)",
  fill: "#ee8e9e"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_102",
  "data-name": "Ellipse 102",
  cx: 3.246,
  cy: 3.218,
  rx: 3.246,
  ry: 3.218,
  transform: "translate(114.077 54.662)",
  fill: "#ee8e9e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_840",
  "data-name": "Path 840",
  d: "M236.236,135.036a3.29,3.29,0,0,1,1.365-1.092,4.914,4.914,0,0,1,.97-.237l1.295-.226a1.663,1.663,0,0,1,.951.021,1.558,1.558,0,0,1,.4.294,5.361,5.361,0,0,0,1.45,1.107c.154.065.315.113.47.178a2.7,2.7,0,0,1,1.371,1.463,4.844,4.844,0,0,1,.268,2.086,3.634,3.634,0,0,1-.074.734,4.706,4.706,0,0,1-.246.673,12.24,12.24,0,0,0-.445,1.426q-.5,1.909-.837,3.858a1.437,1.437,0,0,1-.162.532,1.919,1.919,0,0,1-.448.427,2.788,2.788,0,0,0-.374.369.481.481,0,0,0-.119.2c-.042.192.134.357.268.5a2.4,2.4,0,0,1,.606,1.047.419.419,0,0,1,.1.289.5.5,0,0,0-.031.229.515.515,0,0,0,.122.188.7.7,0,0,1,.134.569,9.173,9.173,0,0,1-3.177.737c-.268.013-.537.013-.805.045-.191.024-.378.063-.569.085a6.185,6.185,0,0,1-.832.021,11.331,11.331,0,0,1-4.259-.633,4.862,4.862,0,0,1,.314-2.028c.268-1.064.335-2.154.537-3.228.134-.733.335-1.455.449-2.194a5.209,5.209,0,0,0-.064-2.222c-.181-.636-.236-1.285-.424-1.92a3.263,3.263,0,0,1-.107-1.95A2.013,2.013,0,0,1,236.236,135.036Z",
  transform: "translate(-120.238 -72.245)",
  fill: "#e30613"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_841",
  "data-name": "Path 841",
  d: "M235.625,120.437a1.922,1.922,0,0,1,.523-1.63,2.784,2.784,0,0,1,1.544-1.074,13.275,13.275,0,0,1,1.562-.02c.46-.036.9-.2,1.361-.266a4.346,4.346,0,0,1,1.245.047,4.76,4.76,0,0,1,1.134.314,4.456,4.456,0,0,1,2.379,3.592,12.871,12.871,0,0,1-.468,4.446l-.3,1.322a26.066,26.066,0,0,0-.7,4.167,8.774,8.774,0,0,0,.655,4.137,8.924,8.924,0,0,1-4.123-4.628c-.209-.544-.365-1.11-.6-1.644-.2-.46-.456-.9-.633-1.366a4.4,4.4,0,0,1-.283-1.659c.011-.426.082-.849.07-1.275a1.751,1.751,0,0,0-.419-1.177,3.636,3.636,0,0,0-.977-.576,4.058,4.058,0,0,1-1.367-1.131,1.234,1.234,0,0,1-.279-.713A8.983,8.983,0,0,0,235.625,120.437Z",
  transform: "translate(-121.22 -64.263)",
  fill: "#454b69"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_842",
  "data-name": "Path 842",
  d: "M233.6,169.916a8.462,8.462,0,0,1-.046.994c-.055.245-.182.466-.258.705a3.326,3.326,0,0,0-.114.847c-.011.239.008.532.223.644.094.049.207.049.3.092s.181.158.125.249-.153.076-.242.093-.184.108-.134.181a.153.153,0,0,0,.078.049.955.955,0,0,1,.252.12.254.254,0,0,1,.1.243.151.151,0,0,1-.084.1.153.153,0,0,1-.132,0,.661.661,0,0,1,.063.266,1.235,1.235,0,0,1-1.051-.23,3.966,3.966,0,0,1-.4-.255,1.989,1.989,0,0,1-.784-1.7,3.934,3.934,0,0,1,.076-.486,7.254,7.254,0,0,1,.2-.826c.093-.286.219-.559.327-.839.231-.6.38-1.223.589-1.828a.277.277,0,0,1,.1-.158.285.285,0,0,1,.149-.028,2.459,2.459,0,0,1,.7.064c.134.04.364.133.427.266s-.038.245-.1.355a2.96,2.96,0,0,0-.37,1.083Z",
  transform: "translate(-119.202 -89.568)",
  fill: "#ee8e9e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_843",
  "data-name": "Path 843",
  d: "M234.861,139.42a.976.976,0,0,0-.172.237,5.912,5.912,0,0,0-.488,2.774c-.024,1.064-.083,2.129-.142,3.2l-.176,3.193c-.017.3-.034.609-.078.911-.207.052-.215.318-.192.532a9.628,9.628,0,0,1,.134,3.893.39.39,0,0,1-.09.173,1.057,1.057,0,0,1,.6-.008c.192.04.377.11.57.154a1.217,1.217,0,0,1,.687.266,13.109,13.109,0,0,0,.45-1.719,6.567,6.567,0,0,1,.334-1.573c.087-.2.205-.382.313-.572a12.438,12.438,0,0,0,1.108-3.229,4.675,4.675,0,0,0,.086-1.6,5.476,5.476,0,0,1-.067-.738,5.629,5.629,0,0,1,.1-.777,5.167,5.167,0,0,0-.157-2.25,6.044,6.044,0,0,0-.805-1.96A2.712,2.712,0,0,0,234.861,139.42Z",
  transform: "translate(-120.242 -75.237)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_844",
  "data-name": "Path 844",
  d: "M234.546,139.208a.983.983,0,0,0-.172.238,5.909,5.909,0,0,0-.488,2.774c-.024,1.064-.083,2.129-.142,3.193l-.176,3.193c-.017.3-.034.609-.078.911-.207.052-.215.318-.191.532a9.675,9.675,0,0,1,.134,3.893.39.39,0,0,1-.09.173,1.056,1.056,0,0,1,.6-.008c.192.04.377.11.57.153a1.226,1.226,0,0,1,.687.266,12.974,12.974,0,0,0,.449-1.72,6.558,6.558,0,0,1,.334-1.571,6.416,6.416,0,0,1,.313-.572,12.4,12.4,0,0,0,1.108-3.23,4.675,4.675,0,0,0,.086-1.6,3.43,3.43,0,0,1,.036-1.515,5.16,5.16,0,0,0-.157-2.248,6.044,6.044,0,0,0-.805-1.96A2.714,2.714,0,0,0,234.546,139.208Z",
  transform: "translate(-120.086 -75.131)",
  fill: "#e30613"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_118",
  "data-name": "Group 118",
  transform: "translate(114.362 53.16)",
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_845",
  "data-name": "Path 845",
  d: "M236.148,118.807a2.784,2.784,0,0,1,1.544-1.074,13.275,13.275,0,0,1,1.562-.02c.46-.036.9-.2,1.361-.266a4.346,4.346,0,0,1,1.245.047,4.761,4.761,0,0,1,1.134.314,3.375,3.375,0,0,1,.56.315,4.8,4.8,0,0,0-1-.266,4.33,4.33,0,0,0-1.244-.047c-.459.059-.9.222-1.362.258a13.572,13.572,0,0,0-1.562.02,2.769,2.769,0,0,0-1.543,1.075,1.92,1.92,0,0,0-.525,1.63,9.046,9.046,0,0,1,.329.874,1.229,1.229,0,0,0,.28.713,4.064,4.064,0,0,0,.985.909c-.1-.048-.209-.1-.31-.148a4.059,4.059,0,0,1-1.367-1.131,1.234,1.234,0,0,1-.279-.713,9.134,9.134,0,0,0-.329-.874A1.908,1.908,0,0,1,236.148,118.807Z",
  transform: "translate(-235.582 -117.423)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_846",
  "data-name": "Path 846",
  d: "M241.33,129.856a1.342,1.342,0,0,0-.181-.156,2.784,2.784,0,0,1,.873.532,1.769,1.769,0,0,1,.419,1.177c.016.426-.06.849-.07,1.273a4.411,4.411,0,0,0,.283,1.66c.177.47.433.9.633,1.366.232.532.388,1.1.6,1.643a8.928,8.928,0,0,0,3.409,4.207c.008.017.015.036.023.053a8.924,8.924,0,0,1-4.123-4.628c-.209-.544-.365-1.11-.6-1.644-.2-.46-.456-.9-.633-1.366a4.4,4.4,0,0,1-.283-1.659c.011-.426.082-.849.07-1.275A1.764,1.764,0,0,0,241.33,129.856Z",
  transform: "translate(-238.336 -123.548)"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1000",
  "data-name": "Rectangle 1000",
  width: 11.002,
  height: 7.716,
  rx: 2.429,
  transform: "translate(16.503 16.203)",
  fill: "#e30613",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1001",
  "data-name": "Rectangle 1001",
  width: 11.002,
  height: 7.716,
  rx: 2.429,
  transform: "translate(27.505 29.773)",
  fill: "#e30613",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1002",
  "data-name": "Rectangle 1002",
  width: 11.002,
  height: 7.716,
  rx: 2.429,
  transform: "translate(119.012 17.534)",
  fill: "#e30613",
  opacity: 0.1
})));

var SvgTabletWithGirl = function SvgTabletWithGirl(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151.337,
    height: 110,
    viewBox: "0 0 151.337 110",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTabletWithGirl, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/TabletWithGirl.fc3e078e.svg";
export { ForwardRef as ReactComponent };